import { Discount, DiscountAdvanced } from '../../types/DiscountTypes'
import { getActivitiesWithDiscountId, getPriceFromCalculation } from './CalculateDiscountHelpers'
import { getBestAvailablePrice } from './DiscountPricingHelpers'
import {
  CalculateDiscountLogic,
  Calculation,
  CalculationDiscount,
  CalculationUserInput,
  DiscountType
} from './CalculateDiscountTypes'

export class AdvancedDiscountLogic implements CalculateDiscountLogic {
  type: DiscountType = 'advanced'
  discountDefinition: DiscountAdvanced

  constructor(discount: Discount) {
    this.discountDefinition = discount as DiscountAdvanced
  }

  chooseEligible(previousCalculations: Calculation[], userInput: CalculationUserInput) {
    if (!userInput.advancedRegistration) return []
    return getActivitiesWithDiscountId(previousCalculations, this.discountDefinition.id)
  }

  calculate(previousCalculations: Calculation[], userInput: CalculationUserInput) {
    const eligibleActivities = this.chooseEligible(previousCalculations, userInput)
    if (!userInput.advancedRegistration) return previousCalculations

    previousCalculations.map((calculation) => {
      if (!eligibleActivities.includes(calculation.activity.id)) return
      if (calculation.activity.id !== userInput.advancedRegistration?.activityId) return

      // Calculate the base price accounting for number of participants
      const basePrice = getPriceFromCalculation(calculation)
      const totalPrice = basePrice * userInput.participantsAmount

      const bestPrice = getBestAvailablePrice(
        calculation.activity,
        userInput.advancedRegistration.type,
        userInput.advancedRegistration.region
      )

      // If no price available (no seats), update finalPrice to total price without discount
      if (bestPrice === undefined) {
        calculation.finalPrice = totalPrice
        return
      }

      // If best price is the same as total price, no discount needed
      if (bestPrice === totalPrice) {
        calculation.finalPrice = totalPrice
        return
      }

      const discountAmount = totalPrice - bestPrice

      const advancedDiscount: CalculationDiscount = {
        type: this.type,
        name: this.discountDefinition.name,
        id: this.discountDefinition.id,
        input: totalPrice,
        discount: discountAmount,
        output: bestPrice,
        discountCalculationType: 'amount',
        discountValue: discountAmount,
        discountGroup: this.discountDefinition.discountGroup
      }

      calculation.discounts = calculation.discounts || []
      calculation.discounts.push(advancedDiscount)
      calculation.finalPrice = advancedDiscount.output
    })

    return previousCalculations
  }
}
